import React from "react";
import styled from "styled-components";

const StyledItemDetailModal = styled.div`
    width: 100%;
    @media (min-width: 576px) {
        padding: 0 20px 10px;
    }
    .category {
        border-radius: 30px;
        padding: 7px 10px;
        font-size: 12px;
        line-height: 16px;
        font-weight: 400;
        &.blue   { color: rgba(44, 185, 255, 1);  background: rgba(44, 185, 255, 0.2); }
        &.red    { color: rgba(226, 29, 37, 1);   background: rgba(226, 29, 37, 0.2); }
        &.orange { color: rgba(245, 126, 42, 1);  background: rgba(245, 126, 42, 0.2); }
        &.purple { color: rgba(94, 64, 153, 1);   background: rgba(94, 64, 153, 0.2); }
        &.gray   { color: rgba(119, 119, 119, 1); background: rgba(236, 236, 236, 1); }
        &.green  { color: rgba(39, 196, 83, 1);   background: rgba(39, 196, 83, 0.15); }
    }

    .product-wrap {
        display: flex;
        gap: 20px;
        margin-bottom: 30px;
        .img-wrap {
            width: 100px;
            height: 100px;
            border-radius: 10px;
            border: 1px solid rgba(245, 126, 42, 0.35);
            overflow: hidden;
            background: rgba(236, 236, 236, 0.5);
            display: flex;
            align-items: center;
            justify-content: center;
            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
            .img-placeholder {
                font-size: 32px;
                color: rgba(143, 143, 143, 0.5);
            }
        }
        .product-name {
            display: block;
            font-size: 20px;
            line-height: 24px;
            font-weight: 400;
            margin-bottom: 15px;
        }
    }

    .values-list {
        list-style: none;
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 20px;
        li {
            .title {
                display: block;
                font-size: 14px;
                line-height: 18px;
                font-weight: 400;
                margin-bottom: 8px;
                color: rgba(119, 119, 119, 1);
            }
            .value {
                font-size: 18px;
                line-height: 22px;
                font-weight: 400;
                &.success { color: rgba(39, 196, 83, 1); }
            }
        }
    }
`;

// Cycle through category pill colours based on category name hash
const CATEGORY_CLASSES = ["blue", "red", "orange", "purple", "gray", "green"];
const getCategoryClass = name => {
    if (!name) return "gray";
    let hash = 0;
    for (let i = 0; i < name.length; i++) hash = name.charCodeAt(i) + ((hash << 5) - hash);
    return CATEGORY_CLASSES[Math.abs(hash) % CATEGORY_CLASSES.length];
};

/**
 * ItemDetailModal
 *
 * Props:
 *   data — item row from the store-summary API:
 *     { itemName, categoryName, itemImage, totalQuantity, totalRevenue, unitPrice }
 */
const ItemDetailModal = ({ data }) => {
    const categoryClass = getCategoryClass(data?.categoryName);

    return (
        <StyledItemDetailModal>
            <div className="product-wrap">
                <figure className="img-wrap">
                    {data?.itemImage ? (
                        <img src={data.itemImage} alt={data?.itemName || "item"} />
                    ) : (
                        <span className="img-placeholder">🍽️</span>
                    )}
                </figure>
                <div>
                    <strong className="product-name">{data?.itemName || "—"}</strong>
                    {data?.categoryName && (
                        <span className={`category ${categoryClass}`}>{data.categoryName}</span>
                    )}
                </div>
            </div>
            <ul className="values-list">
                <li>
                    <span className="title">Total Sold</span>
                    <strong className="value">{data?.totalQuantity ?? "—"} pcs</strong>
                </li>
                <li>
                    <span className="title">Total Revenue</span>
                    <strong className="value success">
                        ${Number(data?.totalRevenue || 0).toFixed(2)}
                    </strong>
                </li>
                <li>
                    <span className="title">Unit Price</span>
                    <strong className="value">
                        ${Number(data?.unitPrice || 0).toFixed(2)}
                    </strong>
                </li>
                <li>
                    <span className="title">Category</span>
                    <strong className="value">{data?.categoryName || "Uncategorized"}</strong>
                </li>
            </ul>
        </StyledItemDetailModal>
    );
};

export default ItemDetailModal;
